export type Stance = "never asked" | "granted" | "denied" | "dismissed" | "cannot";

const DISMISSED = "rally-push-card-dismissed";

export type Held = {
  able: boolean;
  permission: NotificationPermission;
  dismissed: boolean;
};

export function stanceFrom(held: Held): Stance {
  if (!held.able) return "cannot";
  if (held.permission === "granted") return "granted";
  if (held.permission === "denied") return "denied";
  return held.dismissed ? "dismissed" : "never asked";
}

export function cardStands(stance: Stance): boolean {
  return stance === "never asked";
}

export function mayAsk(stance: Stance): boolean {
  return stance === "never asked" || stance === "dismissed";
}

export function ableHere(): boolean {
  return (
    typeof navigator !== "undefined" &&
    "serviceWorker" in navigator &&
    typeof window !== "undefined" &&
    "PushManager" in window &&
    "Notification" in window
  );
}

export function permissionHere(): NotificationPermission {
  return typeof Notification === "undefined" ? "default" : Notification.permission;
}

export function dismissedHere(): boolean {
  try {
    return localStorage.getItem(DISMISSED) === "yes";
  } catch {
    return false;
  }
}

export function dismissTheCard(): void {
  try {
    localStorage.setItem(DISMISSED, "yes");
  } catch {}
}

export function stanceHere(): Stance {
  return stanceFrom({
    able: ableHere(),
    permission: permissionHere(),
    dismissed: dismissedHere(),
  });
}
